<div class="widget__wrap">
  <div class="widget" id="tiles-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Realitní makléři
      </span>
      <span class="widget__header__tools">
        <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
        <a [routerLink]="['estate-agents/add']" class="cta cta--small cta--green">
          <span class="cta__light">Přidat</span> makléře
          <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content"><swb-estate-agents-list [query]="query"></swb-estate-agents-list></div>
  </div>
</div>
